export default __webpack_public_path__ + "static/media/Head_1_Ear_1_C2.3a8ac402.svg";